import { GroupSelectWithRegionsTranslation } from '@/assets/locales/form/GroupSelectWithRegions/GroupSelectWithRegions.translation.en';

export const groupSelectWithRegionsTranslation: GroupSelectWithRegionsTranslation = {
  chosen: 'Wybrano',
  regions: 'Regiony',
  selectedAllRegions: 'Wybrano wszystkie regiony',
};
